// const serverUrl = `${process.env.REACT_APP_SERVER_URL}`;
export const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://voice-api.controlla.xyz';
